import styled from "styled-components";

export const ContractProductsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const ContractProductsTitle = styled.div`
  display: flex;
  align-items: end;
  gap: 4px;

  span,
  h2,
  h2 > span {
    font-family: "Inter", sans-serif;
    line-height: 100%;
    letter-spacing: 0%;
    margin-bottom: 0;
    color: #020618;
  }
  span {
    font-weight: 400;
    font-size: 18px;
  }
  h2,
  h2 > span {
    font-weight: 700;
    font-size: 24px;
  }

  h2 > span {
    display: inline-block;
    max-width: 50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const EmptySearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #020618;
  grid-column: 1 / -1;
  margin-top: 24px;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  animation: fadeIn 0.5s ease-in-out;
`;
